import { RealEstateType } from './realEstateType'
import { Intent } from './intent'
import { TimeHorizon } from './timeHorizon'
import { Ownership } from './ownership'
import { LandDevelopmentPotential } from './landDevelopmentPotential'
import { LandLayout } from './landLayout'
import { LandDevelopmentStatus } from './landDevelopmentStatus'
import { CommercialRealEstateType } from './commercialRealEstateType'
import { ApartmentSubtype, HouseSubtype } from './realEstateSubtype'
import { Furnishing } from './FurnishingType'
import { ValuationRange } from './valuation'
import { SolarIntent } from './solarIntent'
import { PlacementType } from './placementType'

export interface Lead {
  id?: string
  realEstateType?: RealEstateType
  livingSpace?: number
  plotArea?: number
  rooms?: number
  intent?: Intent
  solarIntent?: SolarIntent
  timeHorizon?: TimeHorizon
  ownership?: Ownership
  leadSource: LeadSource
  duplicateUser?: boolean
  landDevelopmentPotential?: LandDevelopmentPotential
  landDevelopmentStatus?: LandDevelopmentStatus
  landLayout?: LandLayout
  commercialRealEstateType?: CommercialRealEstateType
  constructionYear?: number
  created?: number
  realEstateSubtype?: ApartmentSubtype | HouseSubtype
  furnishingType?: Furnishing
  ssoId?: number
  optionalStreet?: string
  optionalHouseNumber?: string
  rangeValuationFromAddress?: ValuationRange
  employment?: string
  extendedBuyerLead?: boolean
  equity?: number
  income?: number
  affordability?: number
  placementType?: PlacementType
  isConsultationAccepted?: boolean
  furtherRealEstateInformation?: string
}

export enum LeadSource {
  REGULAR = 'MAKLERSUCHMACHINE',
  IBW = 'IMMOBILIENBEWERTUNG',
  COOPERATION_EXTERNAL = 'COOPERATION_EXTERNAL',
  IBW_COOPERATION_EXTERNAL = 'IBW_COOPERATION_EXTERNAL',
  COOPERATION = 'COOPERATION',
  IBW_COOPERATION = 'IBW_COOPERATION',
  ATLAS = 'ATLAS',
  IV24_WEBSEITE_D = 'IV24_WEBSEITE_D',
}

export enum OptionalLeadSource {
  IBW_COOPERATION = 'ibw-cooperation',
  RLE_COOPERATION = 'rle_cooperation',
  ATLAS = 'atlas_ibw_realtor-leadengine',
}
